<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Office Fee Payment </v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-row justify="center" dense>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete v-model="status" rounded return-object @change="getStud()" :items="status_list"
                        :loading="onload_loader" label="Select Status" item-text="name" outlined dense
                        prepend-icon="mdi-account-child-circle"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox v-model="registration_no" @change="offline_payment=false;online_payment=false" rounded
                        :items="stud_list" label="Select Student" item-text="name" outlined dense
                        prepend-icon="mdi-account-child-circle"></v-combobox>
                </v-col>
                <v-col cols="3">
                    <v-select rounded :items="aylist" @change="offline_payment=false;online_payment=false"
                        label="Academic Year" item-text="academicyear" item-value="ay_id" outlined dense
                        v-model="ay"></v-select>
                </v-col>
                <span v-if="registration_no">
                    <v-btn class="mt-2 button" small v-if="org_id != 'zeal' && org_id != 'vvp'"
                        @click="proceed();offline_payment=true;online_payment=false" :loading="loader">Proceed</v-btn>
                    <v-btn class="mt-2 button" small v-if="org_id == 'zeal' || org_id == 'vvp'"
                        @click="proceed();offline_payment=true;online_payment=false" :loading="loader">Offline
                        Payment</v-btn>
                    <v-btn class="mt-2 button" small v-if="org_id == 'zeal' || org_id == 'vvp'"
                        @click="proceed_online_payment();offline_payment=false;online_payment=true"
                        :loading="loader">Online Payment</v-btn>
                </span>
            </v-row>
        </v-card>

        <!-- <span v-if="online_payment == true">
          <online-fees-payment-admin></online-fees-payment-admin>
        </span> -->

        <span v-if="offline_payment == true">
            <v-form id="payment-form" @submit.prevent="submit" v-model="disable_pay" ref="admissionfeeform">
                <v-card class="box" v-if="this.show_details_card">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="3">
                            <v-text-field label="Name" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-text-field label="Admission Year" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.learner_addmission_year"></v-text-field>
                            <!-- <strong>Admission Year : </strong>{{ fees_student_master_details.learner_addmission_year }} -->
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field label="Standard" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.standard"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field label="Quota" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.quota"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field label="Total Fees" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.total_fees_amount"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field label="Amount Paid" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.paid_till_now"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field class="padding-bot" label="Balace Fees" readonly outlined dense
                                v-model="fees_student_master_details.balance_amount"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field class="padding-bot" label="Excess Amount" readonly outlined dense
                                v-model="fees_student_master_details.excess_amount"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field class="padding-bot" label="Refunded Amount" readonly outlined dense
                                v-model="fees_student_master_details.refunded_amount"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="2" align="center">
                            <v-btn small class="ma-2" color="error" @click="expand2 = !expand2" v-if="show_challan_btn">
                                Previous Challan
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="2" align="center" v-if="outstanding == 'YES'">
                            <v-btn small class="ma-2" color="primary" v-if="outstanding == 'YES'"
                                @click="dialog_outsatnding = true">
                                Pay Oustanding Fees
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="2" align="center">
                            <v-btn small class="ma-2" color="error" @click="expand1 = !expand1"
                                v-if="this.show_installments_btn">
                                Installments
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="2" align="center">
                            <v-btn small class="ma-2" color="error" @click="dialog_fine = true">
                                Calculate fine
                            </v-btn>
                        </v-col>
                        <!-- && org_id == 'wws' -->
                        <v-col cols="12" sm="2" align="center" v-if="allow_customised_installment_due_date == true">
                            <span>
                                <v-btn small class="ma-2" color="error" @click="dialog_due_date = true">
                                    Change Due Date
                                </v-btn>
                            </span>
                        </v-col>
                        <v-col cols="12" sm="2" align="center" v-if="org_id == 'vvp'">
                            <v-btn small class="ma-2" color="error" @click="dialog_receipt = true">
                                Generate 0 Fee Receipt
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-expand-transition>
                                <v-card v-show="expand2" class="box">
                                    <v-toolbar dense class="toolbar" flat color="white">
                                        <v-toolbar-title>Student Preveious Challan</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <br />
                                    <template v-if="student_challan_details != ''">
                                        <v-data-table :items="student_challan_details" :headers="headers_challan"
                                            class="elevation-1 mytable" dense :search="search">
                                            <template v-slot:item.print="{ item }">
                                                <v-tooltip top color="warning">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn class="pt-none mt-none" outlined rounded small
                                                            color="warning" v-bind="attrs" v-on="on" @click="
                              print_challan(item.challan_no, item.academicyear)
                            ">
                                                            <v-icon color="warning">mdi-printer</v-icon>Print Challan
                                                        </v-btn>
                                                    </template>
                                                    <span> Print Challan!!! </span>
                                                </v-tooltip>
                                            </template>
                                            <template v-slot:item.status="{ item }">
                                                <v-select dense rounded required class="mt-1"
                                                    :items="challan_status_list" item-text="display_name" return-object
                                                    v-model="item.challanstatus" placeholder="Selct Challan Status"
                                                    outlined></v-select>
                                            </template>
                                            <template v-slot:item.remark="{ item }">
                                                <v-text-field rounded label="Remark" outlined dense
                                                    v-model="item.remark"></v-text-field>
                                            </template>
                                            <template v-slot:item.update="{ item }">
                                                <v-btn class="pt-none mt-none button" outlined rounded small @click="
                          chnagechallanstatus(
                            item.challanstatus,
                            item.id,
                            item.remark
                          )
                        ">
                                                    Update
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </template>
                                </v-card>
                            </v-expand-transition>
                        </v-col>
                    </v-row>

                    <v-row justify="center" dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-expand-transition>
                                <v-card v-show="expand1" class="main card-border">
                                    <v-toolbar flat dense class="toolbar">
                                        <v-toolbar-title>Installments</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <br />
                                    <template v-if="installment_list != null">
                                        <!-- <v-data-table class="elevation-1 mytable" :items="installment_list" :headers="headers_installment" dense :search="search"> 

                                        </v-data-table> -->
                                        <v-col cols="12" sm="12" md="12">
                                            <v-simple-table dense class="elevation-1 mytable">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th>Academic Year</th>
                                                            <th>Name</th>
                                                            <th>Total Amount</th>
                                                            <th>Paid Amount</th>
                                                            <th>Remaining Amount</th>
                                                            <th v-if="org_id == 'sbpps'">Weekly Fine (If Applicable)
                                                            </th>
                                                            <th v-if="org_id == 'wws' || org_id == 'vvp'">
                                                                Late Fee Charge (If Applicable)
                                                            </th>
                                                            <th v-else>Fine Start Date</th>
                                                            <!-- <th>Amount To Pay</th> -->
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in installment_list" :key="index">
                                                            <td>{{ item.of_academicyear }}</td>
                                                            <td>
                                                                <strong>{{ item.name }}</strong>
                                                            </td>
                                                            <td>{{ item.fee }}</td>
                                                            <td>{{ item.paid_fee }}</td>
                                                            <td>{{ item.balnace_fee }}</td>
                                                            <td v-if="org_id == 'sbpps'">{{ item.fine }}</td>
                                                            <td v-if="org_id == 'wws' || org_id == 'vvp'">
                                                                {{ item.fine }} Rs. between {{ item.due_date }}.
                                                                <span
                                                                    v-if="item.due_date_variable_fine && item.variable_fine != 0">
                                                                    Daily {{item.variable_fine}} Rs. after
                                                                    {{item.due_date_variable_fine}}
                                                                </span>
                                                            </td>

                                                            <td v-else>{{ item.due_date }}</td>
                                                            <!-- <td>
                                                                <strong>{{ item.balnace_fee + item.fine_due_date }}</strong>
                                                            </td> -->
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </template>
                                </v-card>
                            </v-expand-transition>
                        </v-col>
                    </v-row>

                    <!-- <v-row justify="center" dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-expand-transition>
                                <v-card v-show="expand_dates" class="main card-border">
                                    <v-toolbar flat dense class="toolbar">
                                        <v-toolbar-title>Due Dates</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <template v-if="due_dates_list != ''">
                                        <v-col cols="12" sm="12" md="12">
                                            <v-simple-table dense class="elevation-1 mytable">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th>Installment</th>
                                                            <th>Due Date</th>
                                                            <th>Attachment</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        <tr v-for="(item, index) in due_dates_list" :key="index">
                                                            <td>{{ item.feesinstallmentacademicyear }}</td>
                                                            <td>
                                                                <strong>{{ item.due_date }}</strong>
                                                            </td>
                                                            <td>
                                                            <a :href="basepath+item.url" target="_blank" v-if="item.url != null">
                                                                <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                                                            </a>
                                                            <span v-else style="opacity: 0.5;">--</span>
                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </template>
                                </v-card>
                            </v-expand-transition>
                        </v-col>
                    </v-row> -->
                </v-card>
                <v-card class="box" v-if="accound_record!=''">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Pending Fees</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br>
                    <v-row dense v-for="ar,index in accound_record" :key="index">
                        <v-col cols="12" sm="4" md="4">
                            <center><strong> Academic Year : </strong>{{ ar.ay }}</center>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <center><strong> Balance Fee : </strong>{{ ar.balance }}</center>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <center><strong> Paid Fee : </strong>{{ ar.paid }}</center>
                        </v-col>
                    </v-row>
                    <!-- {{ accound_record }} -->
                </v-card>
                <v-card v-if="stud_name != null" class="box">
                    <span v-if="stud_name != null">
                        <input type="hidden" v-model="stud_id" name="stud_id" />
                        <input type="hidden" v-model="ay" name="academicyear" />

                        <!-- inputs:{{inputs}} -->
                        <v-btn v-if="org_id != 'zeal'" class="button mt-4" @click="addRow" style="float: right;">Add
                            Mode</v-btn>

                        <v-row v-for="(input, index) in inputs" :key="index" style="float: both;">
                            <v-col cols="12" sm="2">
                                <v-combobox dense rounded required :items="mode_list" item-text="name"
                                    v-model="input.mode" label="Payment Mode" name="mode" outlined />
                            </v-col>
                            <v-col
                                v-if="org_id == 'zeal' || org_id == 'wws' || org_id == 'vvp' || org_id == 'sanjivani' || org_id == 'uwws'"
                                cols="12" sm="2" md="2">
                                <v-text-field outlined rounded
                                    :label="org_id == 'sanjivani' ? 'Instrument No' : 'Transaction ID'"
                                    v-model="input.trans_id" placeholder="123" name="trans_id" dense></v-text-field>
                            </v-col>
                            <v-col
                                v-if="org_id == 'wws' || org_id == 'vvp' || org_id == 'sanjivani' || org_id == 'uwws'"
                                cols="12" sm="2" md="2">
                                <v-combobox dense rounded required :items="bank_list" v-model="input.bank" label="Bank"
                                    name="bank" item-text="name" item-value="id" outlined />
                            </v-col>
                            <v-col v-if="org_id == 'wws' || org_id == 'vvp' || org_id == 'uwws'" cols="12" sm="2"
                                md="2">
                                <v-text-field outlined rounded label="Branch Name" v-model="input.branch_name"
                                    placeholder="SBU Pune" name="branch_name" dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field label="* Mode Amount" v-model="input.amount" placeholder="123"
                                    @change="calReceiptAmount" :rules="[(v) => !!v || 'Mode amount is required']"
                                    type="number" name="mode_amount" dense rounded outlined
                                    hint="Mode amount is required"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field rounded label="Amount" placeholder="20000" name="receipt_amount"
                                    v-model="receipt_amount" :rules="[(v) => !!v || 'Amount is required']" required
                                    readonly dense filled outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3">
                                <v-text-field rounded label="Receipt Remark" placeholder="Receipt Remark"
                                    name="receipt_remark" dense outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense rounded outlined v-model="receipt_date" label="Receipt Date"
                                            name="receipt_date" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="receipt_date" name="receipt_date"
                                        @input="menu11 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col v-if="org_id == 'zeal' || org_id == 'sanjivani'" cols="12" sm="3" md="3">
                                <v-menu v-model="menu12" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense outlined rounded v-model="inputs.mode_date"
                                            label="Transaction Date" name="mode_date" prepend-icon="mdi-calendar"
                                            readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="inputs.mode_date" name="mode_date"
                                        @input="menu12 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col v-if="org_id != 'zeal'" cols="12" sm="1" md="1">
                                <v-btn text icon color="grey lighten-1" @click="deleteRow(index)"><v-icon>
                                        mdi-delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-if="org_id == 'vvp'" justify="center" dense>
                            <v-simple-table dense class="mytable ml-4" style="width: 40%;">
                                <thead>
                                    <tr>
                                        <th class="text-center">Installment</th>
                                        <th class="text-center">Discount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in installment_list" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td> <span v-if="item.full_discount > 0">-</span> {{ item.full_discount }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-row>
                        <br>
                        <span v-if="stud_name != null">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Fees Component</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12" class="px-0">
                                <v-simple-table dense class="elevation-1 table-container">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="toolbar">
                                                    <center><strong>Component</strong></center>
                                                </th>
                                                <th class="toolbar">
                                                    <center><strong>Actual</strong></center>
                                                </th>
                                                <th class="toolbar">
                                                    <center><strong>Paid</strong></center>
                                                </th>
                                                <th class="toolbar">
                                                    <center>
                                                        <strong> Balance</strong>
                                                    </center>
                                                </th>
                                                <th class="toolbar">
                                                    <center><strong>Pay Now</strong></center>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="comp in installment_details_list" :key="comp.id">
                                                <td>
                                                    {{ comp.name }}
                                                    <v-tooltip right color="primary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon v-if="comp.remark!=null" v-bind="attrs" v-on="on"
                                                                x-small color="#0f2027">mdi-information</v-icon>
                                                        </template>
                                                        <span>
                                                            {{comp.remark}}
                                                        </span>
                                                    </v-tooltip>

                                                </td>
                                                <td>{{ comp.amount }}</td>
                                                <td>{{ comp.paid_amount }}</td>
                                                <td>
                                                    <b> {{ comp.balance_amount }} </b>
                                                </td>
                                                <td>
                                                    <input class="input text-center" type="number"
                                                        @change="calCompTotal" v-model="comp.current_amount"
                                                        :name="comp.id" :rules="[(v) => !!v || 'Required' || v >= 0]" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{{ comp_total.name }}</td>
                                                <td>{{ comp_total.amount }}</td>
                                                <td>{{ comp_total.paid_amount }}</td>
                                                <td>
                                                    <b> {{ comp_total.balance_amount }} </b>
                                                </td>
                                                <td>{{ comp_total.current_amount }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <hr />
                                <!-- {{ installment_details_list }}  -->
                                <br>
                                <v-row dense justify="center">
                                    <v-col sm="2" v-if="org_id != 'wws' || org_id == 'vvp'">Fine</v-col>
                                    <v-col sm="2" v-else>Late Fee Charge</v-col>
                                    <v-col sm="2" v-if="org_id != 'wws' || org_id != 'vvp'"><v-text-field rounded
                                            label="Fine Amount" v-model="fine_amount" name="fine_amount" type="number"
                                            dense value="0" outlined @change="addfineonline()"></v-text-field></v-col>
                                    <v-col sm="2" v-else><v-text-field rounded label="Late Fee Charge"
                                            v-model="fine_amount" name="fine_amount" type="number" dense value="0"
                                            outlined @change="addfineonline()"></v-text-field></v-col>
                                    <v-col sm="1"></v-col>
                                    <v-col sm="2">Excess Amount</v-col>
                                    <v-col sm="2"><v-text-field rounded label="Excess Amount"
                                            v-model="this.excess_amount" name="excess_amount" type="number" dense
                                            value="0" outlined></v-text-field></v-col>
                                </v-row>
                                <!-- 2222----{{installments_json_pre_trans_data }} -->
                            </v-col>
                        </span>
                        <v-card-actions>
                            <v-row justify="center" dense>
                                <!-- vikas zis change  -->
                                <template v-if="allow_manaul_receipt_no">
                                    <v-checkbox v-model="show_manaul_receipt_no"
                                        label="Do you want to add receipt no manually?"></v-checkbox>
                                    <v-text-field rounded label="Receipt No" v-if="show_manaul_receipt_no" required
                                        v-model.trim="manual_receipt_no" name="manual_receipt_no" dense
                                        outlined></v-text-field>
                                </template>

                                <v-btn @click="submit" rounded :disabled="!disable_pay" :loading="loader" class="button"
                                    :color="disable_pay ? '' : 'grey lighten-1'">Pay</v-btn>
                                <form :action="url" v-if="pg_hidden!=null && pgs.includes('PayTM')" @submit="payment"
                                    name="paytmform" method="POST">
                                    <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                                    <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                                    <input type="hidden" :value="pg_hidden.uid" name="uid" />
                                    <input type="hidden" :value="pg_hidden.studid" name="studid" />
                                    <input type="hidden" :value="pg_hidden.ay" name="ay" />
                                    <input type="hidden" :value="total_amount" name="fee_amount" />
                                    <input type="hidden" value="Offline Installment Payment" name="purpose" />
                                    <input type="hidden" :value="installments_json_pre_trans_data_modified"
                                        name="json_pre_trans_data" />
                                    <v-btn class="button" :disabled="!disable_pay" v-if="total_amount!=0"
                                        type="submit">Pay Online
                                        [PayTM]</v-btn>
                                </form>
                                <form :action="easebuzz_url" v-if="pg_hidden!=null && pgs.includes('EaseBuzz')"
                                    @submit="payment" name="paytmform" method="POST">
                                    <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                                    <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                                    <input type="hidden" :value="pg_hidden.uid" name="uid" />
                                    <input type="hidden" :value="pg_hidden.studid" name="studid" />
                                    <input type="hidden" :value="pg_hidden.ay" name="ay" />
                                    <input type="hidden" :value="total_amount" name="fee_amount" />
                                    <input type="hidden" value="Offline Installment Payment" name="purpose" />
                                    <input type="hidden" :value="installments_json_pre_trans_data_modified"
                                        name="json_pre_trans_data" />
                                    <v-btn class="button" :disabled="!disable_pay" v-if="total_amount!=0"
                                        type="submit">Pay Online
                                        [EaseBuzz]</v-btn>
                                </form>
                            </v-row>
                        </v-card-actions>
                    </span>
                </v-card>
            </v-form>

            <v-row dense>
                <v-col cols="12" sm="12" md="12">
                    <!--   <v-expand-transition> -->
                    <!-- <v-card v-show="expand" class="main card-border"> -->
                    <v-card class="box" v-if="student_receipt_details != ''">
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Previous Receipts</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                       <v-col cols="12" class="px-0">
                            <v-data-table :items="student_receipt_details" :headers="headers"
                                class="elevation-1 mytable" dense :search="search">
                                <template v-slot:[`item.print`]="{ item }">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="my-2" outlined rounded small color="warning"
                                                v-bind="attrs" v-on="on" @click="print(item.receipt_no, item.ay)">
                                                <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                                        </template>
                                        <span> Print Fee Receipt!!! </span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:[`item.edit`]="{ item }">
                                    <div>
                                        <v-avatar style="" size="25" class="edit-avatar">
                                            <v-icon class="edit-v-icon mr-2"
                                                @click="editItemFeeReceipt(item)">edit</v-icon>
                                        </v-avatar>
                                    </div>
                                </template>
                                <template v-slot:[`item.delete`]="{ item }">
                                    <div>
                                        <v-avatar style="" size="25" class="delete-avatar">
                                            <v-icon class="delete-v-icon mr-2"
                                                @click="showReason(item.id)">delete</v-icon>
                                        </v-avatar>
                                    </div>
                                </template>
                            </v-data-table>
                       </v-col>
                    </v-card>
                    <!-- </v-expand-transition> -->
                </v-col>
            </v-row>

            <v-dialog v-model="dialog_print" fullscreen>
                <v-card>
                    <v-toolbar class="toolbar no-display" flat dense>
                        <v-toolbar-title>
                            <strong> Print Receipt </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn fab small color="white" outlined icon @click="dialog_print = false"><v-icon> mdi-close
                            </v-icon></v-btn>
                    </v-toolbar>
                    <student-fee-receipts :receipt_no="receipt_no" :ay="ay"
                        :registration_no="registration_no"></student-fee-receipts>
                    <v-row justify="center">
                        <v-btn class="button no-display" @click="close()">Cancel</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_edit_fee" max-width="1000px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <edit-fee-receipt :payment_mode_list="mode_list" :bank_list="bank_list" :ay="ay"
                            @changedialog="chnaged($event)"></edit-fee-receipt>
                    </v-col>
                    <v-row justify="center" dense>
                        <v-btn class="button mt-3" @click="dialog_edit_fee = false">Cancel</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_outsatnding" fullscreen>
                <v-card>
                    <v-toolbar class="toolbar no-display" flat dense>
                        <v-toolbar-title>
                            <strong> Student Otstanding Fees </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn fab small color="white" outlined icon @click="dialog_outsatnding = false"><v-icon>
                                mdi-close </v-icon></v-btn>
                    </v-toolbar>
                    <student-offline-outstanding :registration_no="registration_no"
                        :ay="ay"></student-offline-outstanding>
                    <v-row justify="center">
                        <v-btn class="button no-display" @click="dialog_outsatnding = false">Cancel</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="show_reason" max-width="1000px">
                <v-card>
                    <v-toolbar class="toolbar no-display" flat dense>
                        <v-toolbar-title>
                            <strong> Add Remark </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn fab small color="white" outlined icon @click="show_reason = false"><v-icon> mdi-close
                            </v-icon></v-btn>
                    </v-toolbar>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="6" md="6">
                            <p><b>Remark</b></p>
                            <v-textarea outlined name="input-7-4" v-model="addRemark" label="Enter Remark">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <!-- receipt id-{{ receipt_id }} <br /> -->
                    <center>
                        <strong>Are you sure you want Delete this Receipt???</strong>
                    </center>
                    <v-row justify="center">
                        <v-btn class="button" text @click="show_reason = false">No</v-btn>
                        <v-btn class="button" text :disabled="addRemark != '' ? false : true"
                            @click="deleteReceipt(addRemark)">Yes</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_fine" max-width="1000px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar class="toolbar no-display" flat dense>
                                <v-toolbar-title v-if="org_id!='wws' || org_id == 'vvp'">
                                    <strong> Calculate Fine </strong>
                                </v-toolbar-title>
                                <v-toolbar-title v-else>
                                    <strong> Calculate Late Fee Charge </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn fab small color="white" outlined icon
                                    @click="dialog_fine = false;fine_inst=[];"><v-icon> mdi-close </v-icon></v-btn>
                            </v-toolbar>
                            <v-row justify="center">
                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete rounded :items="installments_details_fine" multiple
                                        label="Select Installment" item-text="installment" item-value="id" outlined
                                        dense v-model="fine_inst"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-menu v-model="menu15" :close-on-content-click="false" :nudge-right="40"
                                        transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field dense rounded outlined v-model="fine_cal_date"
                                                label="Calculate Fine Until Date" name="fine_cal_date"
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="fine_cal_date" name="fine_cal_date"
                                            @input="menu15 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn small @click="getFine(fine_inst)" class="button">Get Fine / Late Fee
                                        Charge</v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-if="final_fine" dense justify="center">
                                <span class="pt-3" v-if="org_id!='wws' || org_id == 'vvp'"><strong>Total Fine ::
                                        {{final_fine}}</strong></span>
                                <span class="pt-3" v-else><strong>Total Late Fee Charge ::
                                        {{final_fine}}</strong></span>
                                <v-btn small @click="aoplyFine()" class="button">Apply Fine</v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_receipt" max-width="1000px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar class="toolbar no-display" flat dense>
                                <v-toolbar-title>
                                    <strong> Generate 0 Fee Receipt </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn fab small color="white" outlined icon @click="dialog_receipt = false;"><v-icon>
                                        mdi-close </v-icon></v-btn>
                            </v-toolbar>
                            <v-row justify="center">
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field label="Enter Remark" outlined dense rounded
                                        v-model="zero_fee_receipt_remark"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn small @click="generatezerofeereceipt()" class="button">Generate
                                        Receipt</v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_due_date" max-width="1000px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar class="toolbar no-display" flat dense>
                                <v-toolbar-title>
                                    <strong> Change Due Date </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>

                                <v-btn fab small color="white" outlined icon @click="dialog_due_date = false"><v-icon>
                                        mdi-close </v-icon></v-btn>
                            </v-toolbar>
                            <v-row dense justify="center">
                                <v-col cols="12" sm="3" md="3">
                                    <p><b>Installment</b></p>
                                    <v-autocomplete dense required v-model="fees_installment"
                                        :items="fees_installment_list" item-text="name" item-value="id"
                                        label="Installment" outlined persistent-hint
                                        hint="Please Select Installment"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <p><b>Late Fee Charge Start Date</b></p>
                                    <v-text-field clearable outlined dense type="date"
                                        v-model="fine_start_date"></v-text-field>
                                </v-col>
                            
                                <v-col v-if="org_id=='wws' || org_id=='tmvidyalaya'" cols="12" sm="3" md="3">
                                    <p><b>Late Fee Charge End Date</b></p>
                                    <v-text-field outlined clearable dense type="date"
                                        v-model="fine_end_date"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <p><b>Attachment If Any</b></p>
                                    <v-file-input v-model="file_attachment" label="Upload Attachment If Any"
                                        prepend-icon="mdi-paperclip"> </v-file-input>
                                </v-col>
                            </v-row>
                            <!-- receipt id-{{ receipt_id }} <br /> -->
                            <v-row justify="center">
                                <v-btn class="button" text :disabled="fees_installment != '' ? false : true"
                                    @click="updateDueDateForChild()" :loading="loader">Update</v-btn>
                            </v-row>
                            <br />

                            <v-row justify="center" v-if="due_dates_list != ''">
                                <template>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-simple-table dense class="elevation-1 mytable">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th>Installment</th>
                                                        <th v-if="org_id=='wws' || org_id=='tmvidyalaya'">Fixed Due
                                                            Date</th>
                                                        <th>Fine Start Date</th>
                                                        <th>Attachment</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in due_dates_list" :key="index">
                                                        <td>{{ item.feesinstallmentacademicyear }}</td>
                                                        <td v-if="org_id=='wws' || org_id == 'tmvidyalaya'">
                                                            <strong>{{ item.fixed_due_date }}</strong>
                                                        </td>
                                                        <td>
                                                            <strong>{{ item.due_date }}</strong>
                                                        </td>
                                                        <td>
                                                            <a :href="basepath+item.url" target="_blank"
                                                                v-if="item.url != null">
                                                                <v-icon class="mr-2 v-icon-size"
                                                                    color="primary">mdi-eye</v-icon>
                                                            </a>
                                                            <span v-else style="opacity: 0.5;">--</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
        </span>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import EditFeeReceipt from "../Reports/EditFeeReceipt";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import Datepicker from "vuejs-datepicker";
    import StudentOfflineOutstanding from "../OutstandingFees/StudentOfflineOutstanding";
    import StudentFeeReceipts from "./StudentFeeReceipts";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import OnlineFeesPaymentAdmin from "./OnlineFeesPaymentAdmin";
    export default {
        name: "Datepicker",
        // name: "StudentOfflineOutstanding",
        components: {
            "edit-fee-receipt": EditFeeReceipt,
            "student-offline-outstanding": StudentOfflineOutstanding,
            "student-fee-receipts": StudentFeeReceipts,
            "online-fees-payment-admin": OnlineFeesPaymentAdmin,
            Breadcrumbs,
            Datepicker,
        },
        data: () => ({
            showDueDates: false,
            is_fine_applied : false,
            due_dates_list: [],
            file_attachment: null,
            fine_end_date: new Date().toISOString().slice(0, 10),
            fine_start_date: new Date().toISOString().slice(0, 10),
            allow_customised_installment_due_date: null,
            fees_installment_list: [],
            fees_installment: "",
            dialog_due_date: false,
            zero_fee_receipt_remark: null,
            //receipt_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            receipt_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            fine_cal_date: null,
            menu: false,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            modal: false,
            menu2: false,
            menu11: false,
            menu12: false,
            menu15: false,
            dialog: false,
            fine_amount: 0,
            excess_amount: 0,
            stud_id: null,
            payment_mode_list: [],
            student_challan_details: [],
            //receipt_date: "",
            dialog_outsatnding: false,
            dialog_fine: false,
            dialog_receipt: false,
            // components: {
            //     Datepicker,
            // },
            fine_inst: [],
            inputs: [
                {
                    mode: "Cash",
                    bank: "",
                    trans_id: "",
                    amount: 0,
                    mode_date: [],
                    branch_name: "",
                },
            ],
            stud_name: null,
            amount: "",
            installments: [],
            challan_status_list: [],
            headers_challan: [
                { text: "Sr. No", value: "srno", sortable: true },
                { text: "Challan No", value: "challan_no", sortable: true },
                { text: "Amount", value: "amount", sortable: true },
                { text: "Date", value: "challan_date", sortable: true },
                { text: "Challan Status", value: "status", sortable: true },
                { text: "Challan Remark", value: "remark", sortable: true },
                { text: "Update", value: "update", sortable: true },
                { text: "Print Challan", value: "print", sortable: true },
            ],
            headers: [
                { text: "Sr. No.", value: "srno", sortable: true, align: "center" },
                { text: "Receipt No", value: "receipt_no", sortable: true, align: "center" },
                { text: "Amount", value: "amount", sortable: true, align: "center" },
                { text: "Fine", value: "fine", sortable: true, align: "center" },
                { text: "Date", value: "receipt_date", sortable: true, align: "center" },
                { text: "Payment Mode", value: "payment_mode_name", sortable: true, align: "center" },
                { text: "Remark", value: "remark", sortable: true, align: "center" },
                { text: "Print Receipt", value: "print", sortable: true, align: "center" },
                { text: "Edit Receipt", value: "edit", sortable: true, align: "center" },
                { text: "Delete Receipt", value: "delete", sortable: true, align: "center" },
            ],
            headers_installment: [
                { text: "Sr. No.", value: "srno", sortable: true },
                { text: "Payment Stage", value: "installment", sortable: true },
                { text: "Amount", value: "total_fees_amount", sortable: true },
                { text: "Fine", value: "fine", sortable: true },
                { text: "Deadline", value: "due_date", sortable: true },
            ],
            expand_dates: false,
            expand: false,
            expand1: false,
            expand2: false,
            loader: false,
            search: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            registration_no: null,
            aylist: [],
            ay: "",
            fees_student_master_details: [],
            student_receipt_details: [],
            dialog_edit_fee: false,
            edit_fee_receipt: null,
            show_details_card: false,
            show_receipts_btn: false,
            show_installments_btn: false,
            show_challan_btn: false,
            installment_list: [],
            installments_details_fine: [],
            installment: "",
            mode_list: [],
            bank_list: [],
            component: null,
            installment_details_list: [],
            receipt_amount: 0,
            comp_total: null,
            disable_pay: true,
            dialog_print: false,
            overlay: false,
            stud_list: [],
            receipt_no: null,
            outstanding: null,
            org_id: null,
            show_reason: false,
            addRemark: "",
            receipt_id: "",
            offline_payment: false,
            online_payment: false,
            final_fine: null,
            allow_manaul_receipt_no: false,
            manual_receipt_no: null,
            show_manaul_receipt_no: false,
            basepath: "",
            installments_json_pre_trans_data: [],
            installments_json_pre_trans_data_modified: [],
            pg_hidden: [],
            pgs: [],
            url: null,
            total_amount: null,
            status_list: null,
            status: null,
            onload_loader: false,
            easebuzz_url: null,
            accound_record: [],
        }),
        // watch: {
        //     overlay(val) {
        //         val = () => {
        //             this.overlay = false;
        //         };
        //     },
        // },
        created() {
            this.easebuzz_url = process.env.VUE_APP_API_URL + "/PaymentGatewayEaseBuzz/easebuzz"
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_ofc_payment"
        },
        computed: {
            date_fun: () => {
                $(document).ready(function () {
                    var now = new Date();
                    var month = now.getMonth() + 1;
                    var day = now.getDate();
                    if (month < 10) month = "0" + month;
                    if (day < 10) day = "0" + day;
                    var today = now.getFullYear() + "-" + month + "-" + day;
                    $("#datePicker").val(today);
                });
            },
            date_fun_1: () => {
                $(document).ready(function () {
                    var now = new Date();
                    var month = now.getMonth() + 1;
                    var day = now.getDate();
                    if (month < 10) month = "0" + month;
                    if (day < 10) day = "0" + day;
                    var today = now.getFullYear() + "-" + month + "-" + day;
                    $("#datePicker_1").val(today);
                });
            },
        },
        methods: {
            payment() {
                var formData = new FormData(paytmform);
                //    console.log("formData")
                //    console.log(formData)
                this.pg_loader = false
            },
            updateDueDateForChild() {
                // alert(this.fine_end_date)
                // alert(this.fine_start_date )
                if (this.org_id == 'wws' || this.org_id == 'tmvidyalaya') {
                    if (this.fine_end_date < this.fine_start_date) {
                        this.showSnackbar(
                            "red",
                            "Please Select Late Fee Charge End Date Greater Than Late Fee Charge Start Date..."
                        );
                        return;
                    }
                }
                if (this.org_id == 'sbpps' || this.org_id == 'uwws') {
                    this.fine_end_date = null
                }
                this.loader = true;
                let formData = new FormData();
                formData.append("registration_no", this.registration_no.lid);
                formData.append("fees_installment", this.fees_installment);
                formData.append("fine_end_date", this.fine_end_date);
                formData.append("fine_start_date", this.fine_start_date);
                formData.append("ay", this.ay);
                formData.append("file_attachment", this.file_attachment);
                axios
                    .post("FeesStructureInstallment/updateDueDateForChild", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Changed Successfully..");
                            (this.fees_installment = ""), (this.file_attachment = null);
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        this.dialog_due_date = false;
                    });
            },
            showReason(item) {
                this.show_reason = true;
                this.receipt_id = item;
                const formData = {
                    receipt_id: item,
                };
                console.log("formdata", formData);
                // reason_for_delete
            },
            aoplyFine() {
                this.fine_amount = this.final_fine;
                this.is_fine_applied = true;
                this.calReceiptAmount();
            },
            getFine(fine_inst) {
                this.final_fine = null;
                const formData = {
                    installment: fine_inst,
                    fine_cal_date: this.fine_cal_date,
                    registration_no: this.registration_no.registration_number,
                };
                axios
                    .post("/FeesStructureInstallment/getFine", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.final_fine = res.data.final_fine;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.fine_cal_date = null
                    });
            },
            deleteReceipt(remark) {
                const formData = {
                    reason_for_delete: remark,
                    receipt_id: this.receipt_id,
                };
                // console.log("deletereceipt", formData);

                axios
                    .post("/AccountingAndFeesReports/deleteFeeReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Student Fee Receipt deleted successfully");
                            this.show_reason = false;
                            this.addRemark = "";
                            this.proceed();
                        }
                        // this.showReason = false;
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            // deleteItem(item) {
            //     const formData = {
            //         receipt_id: item,
            //     };
            //     axios
            //         .post("/AccountingAndFeesReports/deleteFeeReceipt", formData)
            //         .then((res) => {
            //             if (res.data.flag == "YES") {
            //                 this.showSnackbar("#4caf50", "Student Fee Receipt deleted successfully");
            //                 this.proceed();
            //             }
            //         })
            //         .catch((error) => {
            //             window.console.log(error);
            //         })
            //         .finally(() => {
            //             //close loader
            //         });
            // },
            chnaged(dialog) {
                this.dialog_edit_fee = dialog;
                this.proceed();
            },
            editItemFeeReceipt(item) {
                this.dialog_edit_fee = true;
                this.edit_fee_receipt = item;
                this.$store.commit("setreceipt_data", this.edit_fee_receipt);
            },
            print_challan(challan_no, academicyear) {
                //alert(receipt_no)
                this.challan_no = challan_no;
                // this.ay = academicyear;
                //  this.dialog_print = true;
                // this.overlay = true
                this.$session.set("challan_no", JSON.stringify(challan_no));
                this.$session.set("ay", JSON.stringify(this.ay));
                this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                // this.$router.push({
                //     name: "student-generate-challan",
                // });
                let routeData = this.$router.resolve({
                    name: "student-generate-challan",
                });
                window.open(routeData.href, "_blank");
            },
            print(receipt_no, ay) {
                this.receipt_no = receipt_no;
                // this.dialog_print = true;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                // this.$router.push({
                //     name: "student-fees-receipts",
                // });

                // alert(this.org_id)
                if (this.org_id == "zeal") {
                    let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "wws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-wws",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "uwws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-uwws",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "vvp") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-vvp",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "sanjivani") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-sanjivani",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "desschool") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-des",
                    });
                    window.open(routeData.href, "_blank");
                }
                else {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts" });
                    window.open(routeData.href, "_blank");
                }
            },
            close() {
                this.receipt_no = null;
                this.dialog_print = false;
            },
            clearData() {
                this.is_fine_applied = false;
                this.manual_receipt_no = null;
                this.allow_manaul_receipt_no = false;
                this.show_manaul_receipt_no = false;
                this.fees_student_master_details = [];
                this.student_receipt_details = [];
                this.show_details_card = false;
                this.show_receipts_btn = false;
                this.show_installments_btn = false;
                this.show_challan_btn = false;
                this.installment_list = [];
                this.mode_list = [];
                this.bank_list = [];
                this.installment_details_list = [];
                this.installments_json_pre_trans_data = [];
                this.pg_hidden = [];
                this.pgs = []
                this.stud_name = null;
                this.comp_total = "";
                (this.challan_status_list = []), (this.stud_id = "");
                (this.inputs = [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [] }]), (this.outstanding = null);
                this.receipt_amount = 0;
                (this.fine_amount = 0), (this.excess_amount = 0);
                this.excess_amount = null,
                    this.fine_inst = [];
                this.final_fine = null;
                this.total_amount = null
                this.fine_cal_date = null
                this.receipt_date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
            },
            submit: function (e) {
                if (this.excess_amount != 0) {
                    confirm("Excess Amount is " + this.excess_amount + " you want to continue this payment ?");
                }
                var form = document.getElementById("payment-form");
                var formData = new FormData(form);
                if (this.org_id != "zeal" && this.org_id != 'sanjivani') {
                    formData.append("mode_date", this.receipt_date);
                }
                //   return
                this.loader = true;
                axios
                    .post("FeesStructureInstallment/saveFees", formData)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.showSnackbar("#4CAF50", "Payment Successful...");
                            this.loader = false;
                        }
                        // } else {
                        //    // this.clearData();
                        //     //this.showcomponent=true;
                        // }
                        this.clearData();
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.clearData();
                    })
                    .finally(() => {
                        this.loader = false;
                        this.clearData();
                    });
                return;
            },
            calReceiptAmount() {
                this.receipt_amount = 0;
                for (var i = 0; i < this.inputs.length; i++) {
                    this.receipt_amount += parseFloat(this.inputs[i].amount);
                }
                var pay_comp_now = this.receipt_amount;

                //added by vrushali fine calculation 20-3-23
                if (this.is_fine_applied && pay_comp_now != 0) {
                    pay_comp_now = pay_comp_now - this.final_fine;
                    this.receipt_amount = this.receipt_amount - this.final_fine;
                }
                //vrushali code end

                for (var i = 0; i < this.installment_details_list.length; i++) {
                    console.log(this.installment_details_list[i].balance_amount);
                    this.installment_details_list[i].current_amount = 0;
                    if (pay_comp_now >= this.installment_details_list[i].balance_amount) {
                        this.installment_details_list[i].current_amount = this.installment_details_list[i].balance_amount;
                        pay_comp_now = pay_comp_now - this.installment_details_list[i].balance_amount;
                    } else {
                        this.installment_details_list[i].current_amount = pay_comp_now;
                        pay_comp_now = 0;
                        //break
                    }
                    this.comp_total.current_amount += this.installment_details_list[i].current_amount;
                }
                if (pay_comp_now > 0) {
                    for (var i = 0; i < this.installment_details_list.length; i++) {
                        if (this.installment_details_list[i].name == "Excess") {
                            this.installment_details_list[i].current_amount = pay_comp_now;
                            break;
                        }
                    }
                }
                this.calCompTotal();
                // for(var i=0;i<this.comp_total.length;i++){

                // }
            },
            calCompTotal() {
                this.comp_total.current_amount = 0;
                this.total_amount = 0; 
                for (var i = 0; i < this.installment_details_list.length; i++) {
                    this.comp_total.current_amount += parseFloat(this.installment_details_list[i].current_amount);

                    if (this.installments_json_pre_trans_data[i + 1].lsid == this.installment_details_list[i].id) {
                        if (this.installment_details_list[i].current_amount != 0) {
                            this.installments_json_pre_trans_data[i + 1].amount = this.installment_details_list[i].current_amount
                            this.total_amount = this.total_amount + this.installment_details_list[i].current_amount
                        }
                    }
                }
                // this.installments_json_pre_trans_data = JSON.stringify(this.installments_json_pre_trans_data)
                this.checkPay();
                this.addfineonline()
            },
            addfineonline() {
                //  alert("in if" +  this.installments_json_pre_trans_data[0].fine)
                this.installments_json_pre_trans_data[0].fine = this.fine_amount
                this.total_amount = this.total_amount + parseFloat(this.fine_amount)
                this.installments_json_pre_trans_data_modified = JSON.stringify(this.installments_json_pre_trans_data)
            },
            checkPay() {
                //  alert("this.receipt_amount ---"+this.receipt_amount )
                // alert("this.comp_total.current_amount ---"+this.comp_total.current_amount )
                this.excess_amount = 0;
                if (this.receipt_amount == this.comp_total.current_amount) {
                    this.disable_pay = true;
                } else if (this.receipt_amount > this.comp_total.current_amount) {
                    this.excess_amount = this.receipt_amount - this.comp_total.current_amount;
                    return;
                } else {
                    this.disable_pay = false;
                }
            },
            customFormatter(date) {
                return moment(date).format("DD/MM/YYYY");
            },
            addRow() {
                this.inputs.push({
                    mode: "Cash",
                    bank: "",
                    trans_id: "",
                    amount: 0,
                    mode_date: { value: "" },
                });
            },
            deleteRow(index) {
                this.inputs.splice(index, 1);
                this.calReceiptAmount();
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            proceed_online_payment() {
                if (this.registration_no == null) {
                    this.showSnackbar("#b71c1c", "Please Enter Registration No");
                    return;
                }
                if (this.ay == "" || this.ay == null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year");
                    return;
                }
                localStorage.setItem("setay", this.ay);
                localStorage.setItem("setreg_no", this.registration_no.lid);
                let routeData = this.$router.resolve({ name: "online-fees-payment-admin" });
                window.open(routeData.href, "_blank");
                this.online_payment = true;
            },
            async generatezerofeereceipt() {
                const data = {
                    ay: this.ay,
                    registration_no: this.registration_no.registration_number,
                    zero_fee_receipt_remark: this.zero_fee_receipt_remark,
                };
                try {
                    this.save_loader = true;
                    const res = await axios.post("/FeesStructureInstallment/generateZeroFeeReceipt", data);
                    if (res.data.flag == "YES") {
                        this.dialog_receipt = false;
                        this.proceed();
                        this.showSnackbar("#4CAF50", "Receipt Generated Successfully...");
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.save_loader = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            proceed() {
                if (this.registration_no == "") {
                    this.showSnackbar("#b71c1c", "Please Enter Registration No");
                    return;
                }
                if (this.ay == "" || this.ay == null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year");
                    return;
                }
                const formData = {
                    ay: this.ay,
                    registration_no: this.registration_no.lid,
                };
                axios
                    .post("FeesStructureInstallment/getLearnerData", formData)
                    .then((res) => {
                        //if(res.data.flag_fee == "YES"){
                        // if(res.data.flag == "YES"){
                        if (res.data.flag == "YES") {
                            this.fees_student_master_details = res.data.fees_student_master_details;
                            this.student_receipt_details = res.data.student_receipt_details;
                            this.student_receipt_details.forEach(item => {
                                if (this.org_id === 'sbpps') {
                                    item.amount = item.amount_with_fine
                                }
                            })
                            this.show_details_card = true;
                            this.show_receipts_btn = true;
                            this.show_installments_btn = true;
                            this.show_challan_btn = true;
                            this.installment_list = res.data.installments_details;
                            this.installments_details_fine = res.data.installments_details_fine;
                            this.mode_list = res.data.mode_list;
                            this.bank_list = res.data.bank_list;
                            this.installment_details_list = res.data.installments;
                            this.installments_json_pre_trans_data = res.data.installments_json_pre_trans_data
                            this.pg_hidden = res.data.pg_hidden
                            this.pgs = res.data.pgs
                            this.stud_name = res.data.fees_student_master_details.name;
                            this.comp_total = res.data.comp_total[0];
                            this.stud_id = res.data.stud_id;
                            this.student_challan_details = res.data.student_challan_details;
                            this.outstanding = res.data.outstanding;
                            this.challan_status_list = res.data.challan_status_list;
                            //vikas for zis
                            this.allow_manaul_receipt_no = res.data.allow_manaul_receipt_no;
                            this.allow_customised_installment_due_date = res.data.allow_customised_installment_due_date;
                            this.fees_installment_list = res.data.fees_installment_list;
                            this.due_dates_list = res.data.customized_dates_list;
                            this.accound_record = res.data.accound_record
                            //this.name=
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.clearData();
                            return;
                        }
                        // else  if(res.data.flag_fee == "NO"){
                        //     this.showSnackbar("#b71c1c", res.data.snackbar);
                        // }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                        this.fine_inst = [];
                        this.final_fine = null;
                        this.fine_cal_date = null;
                        this.total_amount = null;
                        this.excess_amount = 0
                        this.excess_amount = null;
                        this.receipt_amount = 0;
                        (this.inputs = [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [] }]);
                        this.is_fine_applied = false;
                        this.fine_amount = 0;
                    });
                //    this.showcard=true
                return;
            },
            getStud() {
                //  console.log(this.status)
                // console.log(this.status.stud_list)
                this.registration_no = null
                this.stud_list = this.status.stud_list
            },
            onload() {
                this.onload_loader = true;
                axios
                    .post("FeesStructureInstallment/getdata")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.aylist = res.data.aylist), (this.ay = res.data.curreny_ay);
                            this.status_list = res.data.all_stud_list;
                            this.onload_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                            this.onload_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
        },
        mounted() {
            this.onload();
            this.org_id = localStorage.getItem("EPS-tenant");
            this.basepath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
    input1 {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }

    input[type="number"] {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .link {
        text-decoration: none !important;
    }

    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    .datepicker-div {
        margin-top: -20px;
    }

    .datepicker-div label {
        color: #00000099;
        font-size: 12px;
        position: relative;
        top: 4px;
    }

    .datepicker {
        border: 1px solid #dddddd;
        padding: 7px 0 7px;
        border-radius: 4px;
        width: 100%;
    }

    .mytable2 /deep/ thead th {
        background: #0f2027 !important;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
    }

    tr,
    td,
    th {
        border: 1px solid #ccc !important;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {

        td,
        th {
            display: table-cell !important;
            font-size: small;
        }

        td+td,
        th+th {
            width: auto;
            font-size: small;
        }
    }

    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
</style>